import WavePortal from "./WavePortal.json";

export const contractAddress = "0xd89659BF790587E00700778aDcbBbA648aa5B2FC";
export const contractABI = WavePortal.abi;
